export default {
  /** 租售价转文字 */
  getPriceToText,
  /** 建筑面积实用面积转成正确格式 */
  getAreaToText,
  /** 建筑面积实用面积均价转成正确格式 */
  getAvgPriceToText,
  getNewPrice,
  getPrice
}

/** 租售价转文字 并保留两位小数 */
/** type {1: "放售", 2: "放租"} */
function getPriceToText(price, type, language) {
  /** 判斷是否過億 */
  const flag = price >= 100000000
  /** */
  let num = '';
  let right = '';
  if (type === 1) {
    num = language === "en-us" ? price / 1000000 : (flag ? price / 100000000 : price / 10000)
  } else if (type === 2) {
    if (language === "en-us") {
      num = price >= 100000000 ? price / 1000000 : price / 1000
    } else {
      num = price >= 100000000 ? price / 100000000 : (price >= 100000 ? price / 10000 : price)
    }
  }
  // 保留两位有效小数，去除无意义的0
  if ((num + '').indexOf('.') !== -1) {
    num = num.toFixed(2)
    num = parseFloat(num)
  }
  // 單位
  if (language === "zh-cn") {
    if (type === 1) {
      right = flag ? '亿' : '万'
    } else if (type === 2) {
      right = flag ? '亿' : (price >= 100000 ? '万' : '')
    }
  } else if (language === "en-us") {
    right = type === 1 ? 'M' : (price >= 100000000 ? 'M' : 'K')
  } else if (type === 1) {
    /** 為 zh-hk時 */
    right = flag ? '億' : '萬'
  } else if (type === 2) {
    right = flag ? '億' : (price >= 100000 ? '萬' : '')
  }
  /** 返回结果 */
  return (language === "en-us" ? 'HK$' : '$') + num + right;
}
/**
 * 建筑面积实用面积均价转成正确格式
 * build:buildingArea 建筑面积
 * sale:saleableArea 实用面积
 *language:当前语言 isVerifyArea:是否均
 * Sq.ft 平方尺
 **/
function getAreaToText(build, sale, language, isVerifyArea) {
  let approx = ''
  /** 判断面积是否确定 */
  if (!isVerifyArea) {
    approx = language === "zh-hk" ? "約" : language === "zh-cn" ? "约" : '~'
  }
  const leftBulid = language === "zh-hk" ? "建" : language === "zh-cn" ? "建" : 'GFA'
  const leftSale = language === "zh-hk" ? "實" : language === "zh-cn" ? "实" : 'SA'
  const right = language === "zh-hk" ? "呎" : language === "zh-cn" ? "尺" : 'sq.ft'
  if (!build && !sale) return ''
  else if (build && sale) return leftSale + approx + build + '/' + leftBulid + approx + sale + right
  else if (!build) return leftSale + (approx ? `${approx}` : '') + sale + right
  else if (!sale) return leftBulid + (approx ? `${approx}` : '') + build + right
}
/**
 * 建筑面积实用面积均价转成正确格式
 * sale: saleableAvgPaidPrice 实用均价
 * build:buildingAvgPaidPrice 建筑均价
 */
function getAvgPriceToText(build, sale, language) {
  const text = language === 'en-us' ? '@$' : '@$'
  if (!build && !sale) return ''
  else if (build && sale) return text + Math.round(build) + '/' + text + Math.round(sale)
  else if (!build) return text + Math.round(sale)
  else if (!sale) return text + Math.round(build)
}
/** 新盤列表轉換價格 */
function getNewPrice(price, language) {
  /** 判斷是否過億 */
  const flag = price >= 100000000
  /** */
  let num = '';
  let right = '';
  if (language === "en-us") {
    num = price >= 100000000 ? price / 1000000 : price / 1000
  } else {
    num = price >= 100000000 ? price / 100000000 : (price >= 100000 ? price / 10000 : price)
  }
  // 保留两位有效小数，去除无意义的0
  if ((num + '').indexOf('.') !== -1) {
    num = num.toFixed(2)
    num = parseFloat(num)
  }
  // 單位
  if (language === "zh-cn") {
    right = flag ? '亿' : (price >= 100000 ? '万' : '')
  } else if (language === "en-us") {
    right = price >= 100000000 ? 'M' : 'K'
  } else {
    right = flag ? '億' : (price >= 100000 ? '萬' : '')
  }
  /** 返回结果 */
  return (language === "en-us" ? 'HK$' : '$') + num + right;
}

/** 价格统一方法 */
function getPrice(price, language) {
  /**
   * Math.round(price / 1000 * 100) / 100
   * 解决js精度不准问题  先乘100  四舍五入取整 在除100
   */
  if (price < 100000) {
    return '$' + price
  } else if (price < 1000000) {
    if (language === 'en-us') {
      return '$' + Math.round(price / 10) / 100 + 'K'
    } else {
      return '$' + Math.round(price / 100) / 100 + (language === 'zh-hk' ? '萬' : '万')
    }
  } else if (price < 100000000) {
    if (language === 'en-us') {
      return '$' + Math.round(price / 10000) / 100 + 'M'
    } else {
      return '$' + Math.round(price / 100) / 100 + (language === 'zh-hk' ? '萬' : '万')
    }
  } else if (language === 'en-us') {
    return '$' + Math.round(price / 10000) / 100 + 'M'
  } else {
    return '$' + Math.round(price / 1000000) / 100 + (language === 'zh-hk' ? '億' : '亿')
  }
}
